import { getCooperationActivity, queryCardInfo, getCrispyRiceReceive, queryUserNickname } from '@/api/crispyRice';
const actions = {
  // 获取活动详情
  async acGetCooperationActivity({ commit, state, rootState, rootGetters }, { activityId }) {
    try {
      const res = await getCooperationActivity({ activityId });
      if (res.data) {
        const data = res.data;
        // 分化商品： 有规格、无规格
        if (data.goodsList && data.goodsList.length) {
          data.specilGoodsList = data.goodsList.filter(item => item.isSpecil == 1);
          data.noSpecilGoodsList = data.goodsList.filter(item => !item.isSpecil);
        }
        // 解析json串内容
        res.data.h5InfoJson = JSON.parse(data.h5InfoJson);
        // 计算活动状态
        let nowTime = new Date().getTime();
        let bTime = (data.beginTime).split('T').join(' ');
        let eTime = (data.endTime).split('T').join(' ');
        let beginTime = new Date(bTime.replace(/-/g, '/')).getTime();
        let endTime = new Date(eTime.replace(/-/g, '/')).getTime();
        data.notBegin = beginTime > nowTime ? true : false;
        data.isEnding = endTime < nowTime ? true : false;
        // 设置领取btn显示状态
        commit('muSetIsReceiveBtnDisabled', data.status === 0 || data.notBegin || data.isEnding);
      }
      return res;
    } catch (error) {

    }
  },
  // 获取卡片信息
  async acQueryCardInfo({ commit, state, rootState, rootGetters }, { activityId }) {
    try {
      const res = await queryCardInfo({ activityId });
      if (res?.data?.reveived) {
        // 设置领取btn显示状态
        commit('muSetIsReceiveBtnDisabled', true);
        // 设置领取状态
        commit('muSetIsReceiveStatus', res?.data?.reveived);
      }
      return res;
    } catch (error) {

    }
  },
};
export default actions;
